// extracted by mini-css-extract-plugin
export default {"actions":"o20pC","action":"eQQPu","title":"GFdKH"};